import React from 'react';

/**
 * Shared hero for inner marketing pages. Cinematic full-bleed atmosphere.
 */
export default function MarketingHero({ title, titleAccent, description, children }) {
  return (
    <header className="relative min-h-[62vh] overflow-hidden bg-oak-950 pt-24 bg-grain">
      <img
        src="/images/community.webp"
        alt=""
        className="absolute inset-0 h-full w-full object-cover opacity-50 animate-ken-burns"
        aria-hidden
      />
      <div className="absolute inset-0 bg-oak-canopy" />
      <div className="pointer-events-none absolute -left-24 top-1/4 h-72 w-72 rounded-full bg-claire-400/20 blur-3xl animate-pulse-soft" />
      <div className="pointer-events-none absolute -right-16 bottom-0 h-80 w-80 rounded-full bg-oak-400/25 blur-3xl animate-drift" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-mist to-transparent" />

      <div className="relative mx-auto flex min-h-[calc(62vh-6rem)] max-w-7xl flex-col justify-end px-4 pb-20 pt-24 sm:px-6 md:pb-24 lg:px-8">
        <div className="section-rule mb-6 animate-rise" />
        <p className="animate-rise font-display text-3xl font-semibold tracking-tight text-claire-200 sm:text-4xl">
          Claireoaks
        </p>
        <h1 className="animate-rise animation-delay-300 mt-3 max-w-3xl font-display text-4xl font-semibold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {title}
          {titleAccent ? <span className="mt-2 block text-claire-200">{titleAccent}</span> : null}
        </h1>
        {description ? (
          <p className="animate-rise animation-delay-500 mt-6 max-w-xl text-lg leading-relaxed text-oak-100/90 sm:text-xl">
            {description}
          </p>
        ) : null}
        {children}
      </div>
    </header>
  );
}
